import type { FaqItemSchemaType } from "@configs/custom-app-config-schema";
import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import i18n from "@helpers/lib/i18n";
import { useAppStore } from "@hooks/useAppStore";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import { useState } from "react";
import { Card, List } from "react-native-paper";

const FaqItem = ({ faq }: { faq: FaqItemSchemaType }) => {
	const theme = useAppTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<Card
			mode="outlined"
			style={{ borderRadius: theme.roundness, marginBottom: 8 }}
		>
			<List.Accordion
				left={(props) => (
					<Icon {...props} name={"message-question-outline"} size={16} />
				)}
				titleNumberOfLines={2}
				title={faq.question}
				expanded={expanded}
				onPress={() => setExpanded(!expanded)}
				style={{
					paddingVertical: 0,
					paddingHorizontal: 8,
					backgroundColor: expanded
						? theme.colors.elevation.level2
						: theme.colors.surface,
				}}
			>
				<List.Item
					title={() => <CustomMarkdownRenderer text={faq.answer} />}
					titleNumberOfLines={8}
				/>
			</List.Accordion>
		</Card>
	);
};

const FaqsContainer = () => {
	const faqs = useAppStore((store) => store.app.accountSettings?.faqs);

	const sortedFaqs = faqs?.sort((a, b) => a.order - b.order);

	const filteredFaqs = sortedFaqs?.filter(
		(faq) => faq.locale === i18n.language,
	);
	return (
		<ScrollContainer>
			<Box padding={16} paddingBottom={84}>
				{filteredFaqs?.map((faq) => (
					<FaqItem key={faq.question} faq={faq} />
				))}
			</Box>
		</ScrollContainer>
	);
};

export default FaqsContainer;
